import React from 'react';

import placeholder from 'assets/calendario/placeholder.gif';
export const ImageWithPlaceholder = ({ src, alt }) => {
  
  const handleError = (event) => {
    event.target.src = placeholder;
  };

  return (
    <img 
      src={src} 
      alt={alt} 
      onError={handleError} 
    />
  );
};